module.exports = __webpack_public_path__ + "img/0fca140.png";